import { createAsyncThunk } from '@reduxjs/toolkit';

function getAccountUsers(_, { extra: { http } }) {
  return http.get(`/account/users`);
}
function getAccountUserEdit({ id }, { extra: { http } }) {
  return http.get(`/account/users/${id}/edit`);
}
function patchAccountUser({ id, user }, { extra: { http } }) {
  return http.patch(`/account/users/${id}`, { user });
}

export const indexAccountUsers = createAsyncThunk(
  'account/users/index',
  getAccountUsers
);
export const editAccountUser = createAsyncThunk(
  'account/users/edit',
  getAccountUserEdit
);
export const updateAccountUser = createAsyncThunk(
  'account/users/update',
  patchAccountUser
);
